import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import './style.scss';
import { MaterialCard } from '@learningblocks/storybook-components';
import { NoteBanner } from '@learningblocks/storybook-components';

import Lab_Coat from './img/gel/ppe/Lab_Coat.svg'
import Protective_Gloves from './img/gel/ppe/Protective_Gloves.svg'
import Safety_Goggles from './img/gel/ppe/Safety_Goggles.svg'
import UV_Protective_Face_Shield from './img/gel/ppe/UV-Protective_Face_Shield.svg'
import Biohazardous_waste from './img/Biohazardous_Waste.svg'
import Trash from './img/Trash.svg'
import Ice_bucket from './img/Ice_Bucket.svg'
import Thermocycler from './img/Thermocycler.svg'
import P2_Tip_Box from './img/P2_Tip_Box.svg'
import P20_Tip_Box from './img/P20_Tip_Box.svg'
import P200_Tip_Box from './img/P200_Tip_Box.svg'
import P1000_Tip_Box from './img/P1000_Tip_Box.svg'
import P2_Pipette from './img/P2_Micropipette.svg'
import P20_Pipette from './img/P20_Micropipette.svg'
import P200_Pipette from './img/P200_Micropipette.svg'
import P1000_Pipette from './img/P1000_Micropipette.svg'

const ImageList = {
  Biohazardous_waste,
  Trash,
  Ice_bucket,
  Trash,
  Thermocycler,
  P2_Tip_Box,
  P20_Tip_Box,
  P200_Tip_Box,
  P1000_Tip_Box,
  P2_Pipette,
  P20_Pipette,
  P200_Pipette,
  P1000_Pipette,
  Lab_Coat,
  Protective_Gloves,
  Safety_Goggles,
  UV_Protective_Face_Shield,
}

export class MaterialsList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      materials: []
    };
  }

  getImage(type){
    return ImageList[type.replaceAll(" ", "_")]
  }
  capitalizeFirstLetter(label){
    return label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase()
  }

  getFullName(componentName, isSolutionTube, type, fullName ){
    if(componentName === 'UV Protective Face Shield'){
      return 'UV protective face shield'
    }

    if(fullName === '1X Sodium borate buffer'){
      return '1X Sodium borate buffer'
    }
    if(componentName == "Solution" && !isSolutionTube){
      return this.capitalizeFirstLetter(fullName);
    } else if(componentName == "Solution"){
      return fullName;
    }

    if(componentName == "Pipette"){
      return this.capitalizeFirstLetter(type + " " + componentName);
    }

    if(componentName == "Tip Box"){
      return this.capitalizeFirstLetter(type + " " + componentName);
    }

    if(componentName == "Trash"){
      return this.capitalizeFirstLetter(type + " container");
    }

    return ( componentName == "Solution" ) ? type : this.capitalizeFirstLetter(type)
  }
  getImageStyle(componentName){
    if(componentName == "Pipette"){
      return {width:'80%', margin: 'auto', marginBottom: '-21%', padding: '0',  paddingTop: '3%', height: '170px'}
    }
    if(componentName == "Tip Box"){
      return {width:'80%', margin: 'auto', padding: '15% 5%'}
    }
    return {width:'80%', margin: 'auto', padding: '5% 5%'}
  }

  buildComponent = (data, index) => {
    const { id, description, size, type, label, circleColor, solutionColor, isSolutionTube, volume, circleOutline, fullName: name, glossaryTitle, glossaryContentId } = data.props
    const solutionTubeProps = { size, type, "label": (label)?parse(label):null, circleColor, solutionColor, volume, circleOutline }

    const componentName = data.component
    const isSolutionTubeProp =  componentName == "Solution" && isSolutionTube === true;
    const materialCardImage = ( componentName == "Pipette" ||  componentName == "Tip Box" ) ? this.getImage(type + " " +  componentName) : this.getImage(type);
    const fullName = this.getFullName(componentName, isSolutionTube, type, name );
    const solutionTube = isSolutionTube ? solutionTubeProps : null;
    const imageStyle = this.getImageStyle(componentName);

    return <div style={{margin: '6px 2px'}}>
           <MaterialCard
              key={index}
              id={id}
              isSolutionTube={isSolutionTubeProp}
              solutionTube={solutionTube}
              imageStyle={imageStyle}
              image={materialCardImage}
              title={type}
              description={description}
              fullName= {fullName}
              glossaryTitle={glossaryTitle}
              contentID={glossaryContentId}
           />
    </div>
  }

  componentDidMount() {
    this.doCompPart(this.props.materials);
  }

    doCompPart = (data) => {
    let groupArr = []

    let grouping = {
      "Reagents": {
        "description": "Chemicals that can be used in this experiment.",
        "components": ["Solution"]
      },
      "Reaction tubes": {
        "description": "Used to hold solutions.",
        "components": ["Solution"]
      },
      "Micropipetting equipment": {
        "description": "Used to measure small volumes.",
        "components": ["Pipettes", "Tip Boxes"]
      },
      "Other materials": {
        "description": "Additional materials required.",
        "components": ["Trash", "Ice Bucket", "Thermocycler"]
      },
      "Personal protective equipment (PPE)": {
        "description": "PPE must be worn to protect skin, eyes, and clothes.",
        "components": ["Lab Coat", "Protective Gloves", "Safety Goggles", "UV Protective Face Shield"]
      },
    }


    Object.keys(grouping).forEach((key, index) => {
        let compArr = []

        grouping[key].components.forEach((component) => {
          if(data.hasOwnProperty(component)){
            data[component].components.forEach((comp, index) => {
              if(key !== "Reagents" && key !== "Reaction tubes" || key == "Reagents" && comp.props.volume > 0 || key == "Reaction tubes" && comp.props.volume <= 0){
                compArr.push(this.buildComponent(comp, index));
              }
            })
          }
        });

        if(typeof compArr[0] != 'undefined'){
          groupArr.push(
            <div aria-label={key} key={index} className="Category">
              <h3 tabIndex={0} aria-label={key} className="CategoryHeading">{key}</h3>
              <h6 tabIndex={0} style={{margin: '-8px 0 16px 0'}}>{grouping[key].description}</h6>
              <div aria-label={key} className="Group">
                {compArr}
              </div>
            </div>
          )
        }
    })


    this.setState({
      materials: groupArr
    });
  };

  render() {
    return(
      <div className={this.props.className}>
        <div className="Materials">{this.state.materials}</div>
      </div>
    )
  }

}
MaterialsList.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  className: PropTypes.string,
  materials: PropTypes.array.isRequired
};

MaterialsList.defaultProps = {
  className: 'materialsList',
};
